<script setup lang="ts">
import { useClipboard } from "@vueuse/core"

import useNotify from "@Composables/useNotify"

//
// Props
interface Props {
  hasTooltip?: boolean
  value: string
}

const props = withDefaults(defineProps<Props>(), {
  hasTooltip: false,
})

//
// Setup
const { copy, isSupported } = useClipboard({ legacy: true })
const { onCopySuccess } = useNotify()

//
// Methods
function getTooltipContent(supported: boolean): Record<string, string> {
  const tooltip: Record<string, string> = {
    content: "Copy to Clipboard",
    placement: "bottom",
    trigger: "focus hover",
  }

  if (!supported) {
    tooltip.content = "Copying to clipboard is not currently supported. Please try again later"
  }

  if (props.hasTooltip) {
    return tooltip
  }

  return {}
}

function onCopy(): void {
  copy(props.value)
  onCopySuccess()
}
</script>

<template>
  <button
    v-if="isSupported"
    v-tooltip="getTooltipContent(true)"
    aria-label="Copy to Clipboard"
    @click="onCopy"
  >
    <slot />
  </button>

  <button
    v-else
    v-tooltip="getTooltipContent(false)"
    aria-label="Copy to Clipboard"
    disabled
  >
    <slot />
  </button>
</template>
